module.exports = __webpack_public_path__ + "static/media/image_manx2.b4e03dfb.png";